import React, { Dispatch, SetStateAction, useState } from "react";
import "./FormSection.scss";

import FormInput from "../../atoms/form-input/FormInput";

interface ISectionForm {
    setActiveIndex: Dispatch<SetStateAction<number>>;
    activeIndex: number;
    titleSection: any;
    inputsSection: any;
    formValues: any;
    setInputValue: any;
    inputsErrorList: string[];
    customErrorMessageList: any;
    inputDisabled: string[];
    validBirthDate?: boolean;
    dateState?: any;
    talleresData?: any;
    key: string;
    setDuration?: (value: string) => void;
    dateStateHelper?: boolean;
    setDateStateHelper?: any;
    alertMessage?: boolean;
    ageAlert?: boolean;
}

const FormSection = (props: ISectionForm) => {
    //Estado para Desplegar la Descripción en el checkbox
    const [openedDescrip, setOpenedDescrip] = useState<number>(-1);

    const handleToggleFilter = (index) => {
        if (openedDescrip === index) {
            setOpenedDescrip(-1);
            return;
        }
        setOpenedDescrip(index);
    };

    return (
        <div
            className={`m-section-form  m-section-form-${props.inputsSection[0].seccion}`}
        >
            {props.inputsSection.map((input, index) => {
                // Evita el render del campo tipo checkbox para la autorizacion de datos.
                // Este campo se renderiza en el componente FormBottom.
                if (input.nombreId !== "dataProcessingAuthorization") {
                    const a = props.customErrorMessageList.filter(
                        (e) => e.nombreId === input.nombreId
                    );
                    return (
                     <>
                        <FormInput
                            key={`input-${input.nombreId}`}
                            modality={props.formValues.modeSpecific}
                            title={input.inputPrincipal}
                            value={props.formValues[input.nombreId]}
                            nombreId={input.nombreId}
                            placeholder={input.placeholder? input.placeholder : ""}
                            type={input.tipoCampo}
                            setInputValue={props.setInputValue}
                            isError={
                                props.inputsErrorList.indexOf(
                                    input.nombreId
                                ) !== -1
                            }
                            errorMessage={
                                a.length > 0
                                    ? a[0].errorMessage
                                    : input.mensajeError
                            }
                            textoTerminos={input.textoTerminos}
                            ayuda={input.ayuda}
                            tituloBotonTerminos={input.tituloBotonTerminos}
                            checked={
                                props.formValues[input.nombreId] && props.formValues[input.nombreId] != " " ? true : false
                            }
                            isRequired={input.obligatorio}
                            disabled={props.inputDisabled?.includes(input.nombreId)}
                            options={input.listaSelect}
                            validBirthDate={props.validBirthDate}
                            tabOrder={input.tabOrder}
                            dateState={props.dateState}
                            talleresData={props.talleresData}
                            icon={input.icon}
                            iconDark={input.iconDark}
                            active={openedDescrip === index}
                            onToggle={() => handleToggleFilter(index)}
                            setDuration={props.setDuration}
                            dateStateHelper={props.dateStateHelper}
                            setDateStateHelper={props.setDateStateHelper}
                            alertMessage={props.alertMessage}
                            ageAlert={props.ageAlert}
                            maxCharacters={input.maximosCaracteres}
                            listValue={input.listValue}
                        />
                     </>
                    );
                }
            })}
        </div>
    );
};

export default FormSection;
